/** @format */

import React, { Fragment, useEffect, useState } from "react";
import { FadeLoader } from "react-spinners";
import { useSelector, useDispatch } from "react-redux";
import { profileSelector } from "store/reducers/ProfileReducer";
import { getProviderProfile } from "store/actions/profile";
import { Col } from "react-bootstrap";
import { ReactComponent as HeaderIcon } from "images/svg/empty-tickets.svg";
import { ReactComponent as SelectedIcon } from "images/svg/selected-fellows.svg";
import { ReactComponent as CommunityIcon } from "images/svg/learning-community-faq.svg";
import { ReactComponent as DeepTechIcon } from "images/svg/deeptech-faq.svg";
import { Link } from 'react-router-dom';
import { ReactComponent as SearchIcon } from "images/svg/search.svg";
import Select from "react-select";
import { selectStyles } from "./selectStyles";

import FellowLayout from "../../Fellow";
import DeepTechFaqs from "./containers/DeepFaqs";
import SelectedFaqs from "./containers/SelectedFaqs";
import CommunityFaqs from "./containers/CommunityFaqs";
import { useGetAllFAQsQuery } from "store/services/adminAPI";

const FilterOptions = [
  { value: "desc", label: "Newest to Oldest" },
  { value: "asc", label: "Oldest to Newest" },
];

const FellowFaqs = () => {
  const { profileInfo, isLoading } = useSelector(profileSelector);
  const profile = profileInfo?.data?.profile;
  const fellowType = profile?.current_program ?? null;

  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("selected");
  const [skip, setSkip] = useState(true);
  const [program, setProgram] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSort, setSort] = useState(FilterOptions[0]);

  const [filter, setFilter] = useState(
    `page=1${program ? `&program=${program}` : ""}`
  );

  const { data, isLoading: loadingFaQs, isFetching: fetchingFAQs } = useGetAllFAQsQuery(filter, {
    skip: skip,
  });

  const handleSearch = () => {
    setFilter(`search=${searchTerm}`);
  };

  const handleSort = (selectedOption) => {
    setSort(selectedOption);
    setFilter(`sort=${selectedOption.value}`);
  };

  useEffect(() => {
    dispatch(getProviderProfile());
  }, [dispatch]);

  useEffect(() => {
    if (fellowType) {
      setProgram(fellowType);
      setFilter(`page=1&program=${fellowType}`);
      setSkip(false);
    }
  }, [fellowType]);



  const tabs = [
    {
      id: "selected",
      title: "Selected Fellows",
      icon: <SelectedIcon className="tab-icon" />,
      component: (
        <SelectedFaqs
          faqs={data?.data?.filter(
            (item) => item.faq_type.name === "Selected Fellows"
          )}
        />
      ),
    },
    {
      id: "community",
      title: "Learning Community",
      icon: <CommunityIcon className="tab-icon" />,
      component: (
        <CommunityFaqs
          faqs={data?.data?.filter(
            (item) => item.faq_type.name === "Learning Community"
          )}
        />
      ),
    },
    {
      id: "deeptech",
      title: "Deeptech",
      icon: <DeepTechIcon className="tab-icon" />,
      component: (
        <DeepTechFaqs
          faqs={data?.data?.filter((item) => item.program === "deeptech")}
        />
      ),
    },
  ];

  return (
    <Fragment>
      <FellowLayout>
        <div className="support-banner">
          <div className="welcome-left">
            <div className="welcome-text">
              <h4>Can't Find What You Are Looking For?</h4>
              <h6>Get quick support from our support team</h6>
            </div>
            <div className="welcome-button">
              <Link to="/fellow/support">
                <button type="button" className="btn btn-primary">
                  Contact Support
                </button>
              </Link>
            </div>
          </div>
          <div className="">
            <HeaderIcon />
          </div>
        </div>

        {loadingFaQs || isLoading || fetchingFAQs ? (
          <div className="d-flex justify-content-center align-items-center height-15 bg-white">
            <FadeLoader color="#36d7b7" />
          </div>
        ) : profile ? (
          <>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h3 className="m-0">Frequently Asked Questions</h3>
            </div>

            <div className="row">
              <Col xl={12}>
                <section className="custom-tab-1">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="support-tabs-container">
                      {tabs.map((tab) => (
                        <button
                          key={tab.id}
                          className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.icon}
                          <span className="ml-2">{tab.title}</span>
                        </button>
                      ))}
                    </div>

                    <Select
                      value={selectedSort}
                      onChange={handleSort}
                      options={FilterOptions}
                      styles={selectStyles}
                      components={{
                        IndicatorSeparator: () => null
                      }}
                    />
                  </div>
                  <div className="support-search-wrapper">
                    <div className="support-search-icon">
                      <SearchIcon />
                    </div>
                    <input
                      type="text"
                      className="support-search-input"
                      placeholder="Search for Articles"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                    />
                  </div>

                  <div className="tab-content">
                    {tabs.find((tab) => tab.id === activeTab)?.component}
                  </div>
                </section>
              </Col>
            </div>
          </>
        ) : null}
      </FellowLayout>
    </Fragment>
  );
};

export default FellowFaqs;